import type { PdfResponse, PdfUploadResponse } from "../types/pdfFileResponse";
/**
 * ### docs:
 * upload pdf file to server
 */
export const uploadPdf: UploadPdf = async (file) => {
  const formData = new FormData();
  formData.append("pdf", file);
  if (file.name.length > 50) {
    throw new Error("Pdf filename too long");
  }
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APP_WS_SERVER_URL}/upload-pdf`,
      {
        method: "POST",
        // You might need to add headers like 'Content-Type': 'application/pdf' or 'multipart/form-data'
        // depending on how the backend expects the PDF file.
        body: formData,
      },
    );
    // debugger;
    if (response.status === 406) {
      const data = await response.json();
      throw new Error(data?.message || "Pdf Too large");
    }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // TODO move this to mapper
    const data: PdfResponse = await response.json();
    return {
      filename: file.name,
      pages: data.pages.map((p) => p.imageUrl),
      totalPages: data.metadata.pageCount,
    };
  } catch (error) {
    console.error("Error uploading PDF:", error);
    throw error;
  }
};

/**
 * mock the server response for the file upload
 *
 * useful for testing the front end logic without the worry from the server
 */
export const mockFileUPload: UploadPdf = async (file) => {
  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 2000));

  // Mock response with example image URLs
  const mockResponse: PdfUploadResponse = {
    filename: file.name,
    totalPages: 3,
    pages: [
      "https://picsum.photos/600/400.jpg",
      "https://picsum.photos/600/600.jpg",
      "https://picsum.photos/500/500.jpg",
    ],
    sized: file.size,
  };

  return mockResponse;
};

type UploadPdf = (file: File) => Promise<PdfUploadResponse>;
